import { Fragment, ReactElement } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, styled } from '@mui/material';
import { observer } from 'mobx-react-lite';

interface CConfirmModalProps {
  isOpen: boolean;
  title: string;
  content?: string;
  confirmText?: string;
  onConfirm?: () => void;
  cancelText?: string;
  onCancel?: () => void;
  customButton?: ReactElement;
}

export const CConfirmModal = observer(
  ({
    isOpen,
    title,
    content,
    confirmText,
    onConfirm,
    cancelText,
    onCancel,
    customButton,
  }: CConfirmModalProps) => {
    return (
      <StyledDialog fullWidth open={isOpen} onClose={onCancel}>
        <StyledDialogTitle>{title}</StyledDialogTitle>

        {content && <StyledDialogContent>{content}</StyledDialogContent>}

        <DialogActions>
          {customButton ? (
            customButton
          ) : (
            <Fragment>
              <StyledCancelButton variant="contained" onClick={onCancel}>
                {cancelText}
              </StyledCancelButton>
              <StyledConfirmButton variant="contained" onClick={onConfirm}>
                {confirmText}
              </StyledConfirmButton>
            </Fragment>
          )}
        </DialogActions>
      </StyledDialog>
    );
  },
);

export default CConfirmModal;

const StyledDialog = styled(Dialog)(() => ({
  '.MuiPaper-root': {
    borderRadius: '16px',
  },
  maxWidth: '400px',
  margin: 'auto',
}));

const StyledDialogTitle = styled(DialogTitle)(() => ({
  fontWeight: 700,
  fontSize: '18px',
  lineHeight: '150%',
  textAlign: 'center',
}));

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '150%',
  textAlign: 'center',
  color: theme.palette.grey[500],
}));

const StyledCancelButton = styled(Button)(({ theme }) => ({
  width: '50%',
  height: '50px',
  fontWeight: 700,
  fontSize: '14px',
  lineHeight: '150%',
  borderRadius: '8px',
  backgroundColor: theme.palette.grey[300],
  color: theme.palette.grey[600],
}));

const StyledConfirmButton = styled(Button)(() => ({
  width: '50%',
  height: '50px',
  fontWeight: 700,
  fontSize: '14px',
  lineHeight: '150%',
  borderRadius: '8px',
}));
